<template>
  <div class="landing-wrapper df fdc aifs f1 w100p">

    <div class="top-bar-global w100p df jcsb aic breadcrumb-wrapper">
      <div class="breadcrumb df f1">
        <h2 class="breadcrumb-other" @click="goTo('/me')">Home</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2 class="breadcrumb-other" @click="goTo('/templates')">My Templates</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2>{{template.name}}</h2>
      </div>
    </div>

    <div class="whole-page-box-global w100p df fdc"">
        <div class="h3wrap">
          <h3>
            {{template.steps.length}} step{{template.steps.length == 1 ? '' : 's'}}
          </h3>
        </div>
      </p>
    </div>




  </div>
</template>

<script>
import router from '@/router'
import tasting_templates from '@/util/tasting_templates'
export default {
  // import Login from '../components/Login'

  name: 'Template',
  data () {
    return {
      templateId: '',
      template: {}
      // mode: 'login' // login/register
    }
  },
  props: [],
  components: {

  },
  methods: {
    goTo (path) {
      router.push(path)
    }
  },
  computed: {

  },
  created () {
    let templateid = this.$route.params.templateid
    this.templateid = templateid
    this.template = tasting_templates[templateid]
  }
}
</script>

<style scoped lang="scss">

  @import "../styles/_colors.scss";
  @import "../styles/elements/_text.scss";
  h2 {
    font-family: 'CA SaygonText', sans-serif;
  }
  .landing-wrapper {
    padding: 15px;
    padding-top: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Template.vue